// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch-team-modal .switch-team-modal-body{min-height:200px}.switch-team-modal .team-list{padding:10px 0;box-shadow:0 1px 0 0 #dee0e3}.switch-team-modal .team-list .team-name{font-size:16px;font-weight:400;color:#1f2329;line-height:22px;max-width:360px;margin-left:16px;margin-right:20px}.switch-team-modal .footer-dialog{margin-top:20px}.switch-team-modal .ivu-page{display:inline-block}", ""]);
// Exports
module.exports = exports;
